import {
  Table,
  Typography,
} from "antd";
import {
  useMemo,
  useContext,
} from "react";

import EmployeeProfile from "@/components/cards/EmployeeProfile";
import ContextMenu from "@/components/containers/ContextMenu";
import { UserContext } from "@/context/UserContext";
import { formateISODateToStr } from "@/utils";
import { useColumnConfig } from "@/hooks/useColumnConfig";

const LOCAL_STORAGE_KEY = "laborCostsTableColumnParameters";

const COLUMN_LABELS = {
  author: "Автор",
  recorded_at: "Дата исполнения",
  hours: "Количество часов",
  comment: "Комментарий",
};

// Таблица трудозатрат
const LaborCostsTable = ({
  data,
  loading,
  pagination,
  onChange,
  onEditItem,
  onDeleteItem,
  rowClassName,
  // rowSelection,
  resize = false,
  readOnly = false,
  isAdmins = false,
  canEditActual = true,
}) => {
  const userCtx = useContext(UserContext);
  const user = userCtx?.user || null;
  const employee_uuid = user?.employee_uuid || null;

  // Базовые колонки
  const baseColumns = useMemo(
    () =>
      [
        {
          title: COLUMN_LABELS.author,
          dataIndex: "author",
          key: "author",
          width: 250,
          ellipsis: true,
          render: (author) =>
            author ? <EmployeeProfile noAvatar {...author} /> : "—",
        },
        {
          title: COLUMN_LABELS.recorded_at,
          dataIndex: "recorded_at",
          key: "recorded_at",
          width: 160,
          // sorter: (a, b) =>
          //   new Date(a.recorded_at) - new Date(b.recorded_at),
          render: (date) => (date ? formateISODateToStr(date) : "—"),
        },
        {
          title: COLUMN_LABELS.hours,
          dataIndex: "hours",
          key: "hours",
          width: 140,
          align: "right",
          // sorter: (a, b) => (a.hours || 0) - (b.hours || 0),
          render: (hours) =>
            hours != null ? (
              <Typography.Text>
                {Number(hours).toLocaleString("ru-RU", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2,
                })}
              </Typography.Text>
            ) : (""),
        },
        {
          title: COLUMN_LABELS.comment,
          dataIndex: "comment",
          key: "comment",
          ellipsis: true,
          render: (comment) => comment || "",
        },
        {
          title: "",
          key: "actions",
          width: 60,
          align: "center",
          fixed: "right",
          render: (_, item) => {
            const isAuthor = item.author_uuid === employee_uuid;

            return !readOnly && (isAuthor || isAdmins) && canEditActual ? (
              <ContextMenu
                vertical
                onEdit={() => onEditItem?.(item)}
                onDelete={() => onDeleteItem?.(item)}
              />
            ) : (<></>)
          }
        },
      ].filter(Boolean),
    [onEditItem, onDeleteItem, readOnly, canEditActual, employee_uuid, isAdmins]
  );

  const { columns, components } = useColumnConfig(
    baseColumns,
    user.user_uuid,
    LOCAL_STORAGE_KEY,
    {
      resize,
      columnLabels: COLUMN_LABELS,
    }
  );

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      components={resize ? components : undefined}
      scroll={{ x: "100%" }}
      bordered
      tableLayout="fixed"
      rowClassName={rowClassName}
    // rowSelection={rowSelection}
    />
  );
};

export default LaborCostsTable;
